(() => {
  'use strict';

  const root = document.getElementById('settingsRoot');
  if (!root) return;
  let rendered = false;

  async function renderNewsletterPanel() {
    const accountPanel = document.getElementById('accountPanel');
    if (!accountPanel || rendered) return;
    const response = await fetch('/api/newsletter/preference', { headers: { accept: 'application/json' } }).catch(() => null);
    if (!response?.ok) return;
    const preference = await response.json().catch(() => null);
    if (!preference) return;
    rendered = true;
    const panel = document.createElement('section');
    panel.className = 'panel newsletter-settings-panel';
    panel.innerHTML = `<h2>Weekly roundup email</h2><p>Choose whether your account receives the weekly FreeMinecraftMods roundup.</p><label class="settings-row"><span><strong>Send me the weekly roundup</strong><small>New projects, updated listings, and safe-download guidance.</small></span><input type="checkbox" id="newsletterOptIn" ${preference.opted_in !== false ? 'checked' : ''}></label><p class="form-note" id="newsletterPreferenceStatus" aria-live="polite"></p>`;
    accountPanel.insertAdjacentElement('afterend', panel);
    panel.querySelector('#newsletterOptIn')?.addEventListener('change', async event => {
      const status = panel.querySelector('#newsletterPreferenceStatus');
      if (status) status.textContent = 'Saving...';
      const save = await fetch('/api/newsletter/preference', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ opted_in: event.target.checked }) }).catch(() => null);
      if (status) status.textContent = save?.ok ? (event.target.checked ? 'Weekly roundup enabled.' : 'Weekly roundup disabled.') : 'Could not save this preference.';
    });
  }

  const observer = new MutationObserver(renderNewsletterPanel);
  observer.observe(root, { childList: true, subtree: true });
  renderNewsletterPanel();
})();
